import { Pipe, PipeTransform } from '@angular/core';
import { CacheService } from '@df/core/cache/cache';
import chunk from 'lodash-es/chunk';

/**
 * chunk array on arrays containing 'size' number of elements
 */
@Pipe({
    name: 'partition',
    standalone: true
})
export class PartitionPipe implements PipeTransform {
    constructor(private cacheService: CacheService) {}

    transform<T>(array: T[] | undefined, size: number | string, skipCache: boolean = false): T[][] | undefined {
        if (array === undefined) {
            return undefined;
        }

        if (typeof size === 'string') {
            size = Math.ceil(array.length * new Function(`return ${size}`)());
        }

        const doTransform = () => chunk(array, <number>size);

        return skipCache ? doTransform() : this.cacheService.get(['PartitionPipe', array, size], doTransform);
    }
}
